import React, { useContext, useState } from "react";
import {
  Button,
  Label,
  Table,
  Menu,
  Icon,
  Container,
  Confirm,
  List,
} from "semantic-ui-react";
import JobPositionStore from "../../../app/stores/jobpositionStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
const JobPositionList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [jobpositionId, setJobPositionId] = useState("");
  const jobpositionStore = useContext(JobPositionStore);
  const {
    jobpositionsByName: jobpositionsByName,
    deleteJobPosition: deleteJobPosition,
    certificateRegistry,
    submitting,
    target,
  } = jobpositionStore;

  return (
    <Container fluid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>File</Table.HeaderCell>
            <Table.HeaderCell>Certificate</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {jobpositionsByName.map((jobposition) => (
            <Table.Row key={jobposition.id}>
              <Table.Cell>
                <strong>{jobposition.name}</strong>
              </Table.Cell>
              <Table.Cell>{jobposition.description}</Table.Cell>
              <Table.Cell>
              { (jobposition.url) &&
                 <Button
                 as="a"
                 href={`${jobposition.url}`}
                 target="_Blank"
                 size='mini'
                 color="green"
                 content='Preview'
                 />
                }
              </Table.Cell>
              <Table.Cell>
              <List bulleted>
                {jobposition.certificateId.map((cert: any) => (
                  <List.Item>{certificateRegistry.get(Number(cert)).name}</List.Item>
              ))}
                </List>
                </Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                <Button
                    as={Link}
                    to={`/hrmanagement/jobposition-edit/${jobposition.id}`}
                    size="mini"
                    icon="edit"
                    color="yellow"
                    title="Edit"
                  />
                  <Button
                    name={jobposition.id}
                    size="mini"
                    loading={target === jobposition.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setJobPositionId(jobposition.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteJobPosition(jobpositionId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default observer(JobPositionList);
